





































import {Vue, Mixins, Component} from 'vue-property-decorator';
import NoticeCategoryData from '@/components/board/mixins/NoticeCategoryData';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {GetNoticeByNoticeNoRequest} from 'supporter';
import {setCookie} from '@/utils/cookieUtils';

@Component({
  components: {PageFormSelect}
})
export default class NoticeListMoveNotice extends Mixins(NoticeCategoryData) {
  get noticeNos() {
    return this.$route.params.noticeNos;
  }

  private noticeCategoryValue: string = '';
  private title: string = '';

  private move(): void {
    if (this.noticeCategoryValue) {
      const data: any = {
        noticeNos: this.noticeNos.split(','),
        noticeCategory: this.noticeCategoryValue
      };
      this.$api.putNotice({data}).then((result: any): void => {
        const data = result.data;
        setCookie('boardNoticeMovePopIsDone', '1');
        alert(this.toI18n('BOARD_NOTICE_LIST_SUCCESS') + data.successCount + this.toI18n('BOARD_NOTICE_LIST_KEY'));
        this.close();
      });
    } else {
      alert(this.toI18n('BOARD_NOTICE_LIST_PLEASE_SELECT_A_CATEGORY'));
    }
  }
  private close(): void {
    window.close();
  }

  private created(): void {
    Vue.set(this.noticeCategoryData, 0, {
      value: '',
      label: this.toI18n('BOARD_NOTICE_LIST_ANNOUNCEMENT_CATEGORY_SELECTION')
    });
    document.body.classList.add('popup');
    const noticeNos: string[] = this.noticeNos.split(',');
    const noticeCount: number = noticeNos.length;
    if (noticeCount === 1) {
      const resquest: GetNoticeByNoticeNoRequest = {
        pathParams: {
          noticeNo: noticeNos[0]
        }
      };
      this.$api.getNoticeByNoticeNo(resquest).then((result: any): void => {
        this.title = result.data.noticeTitle;
      });
    } else if (noticeCount > 1) {
      this.title = noticeCount + this.toI18n('BOARD_NOTICE_LIST_KEY');
    }
  }
}
